import * as React from 'react';

const ForsiaLinkedinIcon = ({
  height = 32,
  width = 32,
}: {
  height: number;
  width: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14134_53122)">
      <path
        d="M22 0H10C4.47715 0 0 4.47715 0 10V22C0 27.5228 4.47715 32 10 32H22C27.5228 32 32 27.5228 32 22V10C32 4.47715 27.5228 0 22 0Z"
        fill="#C5E86C"
      />
      <path
        d="M11.91 9.75004C11.91 10.56 11.26 11.21 10.46 11.21C9.66 11.21 9.01 10.56 9.01 9.75004C9.01 8.94004 9.66 8.29004 10.46 8.29004C11.26 8.29004 11.91 8.94004 11.91 9.75004ZM11.92 12.38H9V21.71H11.92V12.38ZM16.57 12.38H13.67V21.71H16.57V16.81C16.57 14.09 20.09 13.86 20.09 16.81V21.71H23V15.8C23 11.2 17.8 11.37 16.57 13.63V12.37V12.38Z"
        fill="#04330F"
      />
    </g>
    <defs>
      <clipPath id="clip0_14134_53122">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ForsiaLinkedinIcon;
